import { jsx as _jsx } from "react/jsx-runtime";
import { formatDate, formatDateTime, filterDateRange } from "../utils";
import { createColumnHeader } from "./column-header";
/**
 * Create a date/datetime column with automatic formatting
 */ export function createDateColumn(accessorKey, title, options = {}) {
    const { format = "date", locale, fallback = "-", sticky, enableSorting = true, enableFiltering = false } = options;
    return {
        accessorKey,
        meta: {
            label: title,
            sticky,
            ...enableFiltering && {
                filterType: "dateRange"
            }
        },
        header: createColumnHeader(title),
        cell: ({ row })=>{
            const value = row.getValue(accessorKey);
            if (!value) {
                return fallback;
            }
            const formatted = format === "datetime" ? formatDateTime(value, locale) : formatDate(value, locale);
            return /*#__PURE__*/ _jsx("span", {
                className: "whitespace-nowrap",
                children: formatted
            });
        },
        enableSorting,
        enableColumnFilter: enableFiltering,
        ...enableFiltering && {
            filterFn: filterDateRange
        }
    };
}

//# sourceMappingURL=date-column.js.map